import { Component, cloneElement, Children } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { close } from './actions';
import { isOpen } from './selectors';

class Modal extends Component {
  componentWillUnmount() {
    this.props.close(this.props.name);
  }

  render() {
    const { children, ...restProps } = this.props;

    return cloneElement(Children.only(children), restProps);
  }
}

Modal.propTypes = {
  close: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default connect(
  (state, { name }) => ({ open: isOpen(name, state) }),
  {
    close,
  },
)(Modal);
